export default __webpack_public_path__ + "static/media/Frames.0db38d4b.svg";